import 'slick-carousel';

const $ = window.jQuery;

$(document).ready(function() {
    $('.block-hero-carousel.multiple-carousel-items').slick({
        dots: true,
        appendDots: '.carousel-controls .dots',
        dotsClass: 'custom-dots',
        customPaging: function (slider, i) {
            var slideNumber = (i + 1),
                totalSlides = slider.slideCount;
            return '<span class="screen-reader-text">' + slideNumber + '/' + totalSlides + '</span>';
        },
        fade: false,
        infinite: true,
        draggable: false,
        speed: 500,
        slidesToShow: 1, 
        autoplay: true,
        autoplaySpeed: 10000,
        arrows: false,
    });

    $('.slick-prev').click(function(){ 
		$(this).parent().parent().parent().parent().siblings('.block-hero-carousel').slick('slickPrev');
	} );
	
	$('.slick-next').click(function(e){
		e.preventDefault(); 
		$(this).parent().parent().parent().parent().siblings('.block-hero-carousel').slick('slickNext');
	} );
});

export default {};